import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function MCQList() {
  const [mcqs, setMcqs] = useState([]);
  const [showAnswer, setShowAnswer] = useState(null);

  useEffect(() => {
    axios.get('https://css-67zw.onrender.com/api/mcqs')
      .then(res => setMcqs(res.data))
      .catch(err => console.log(err));
  }, []);

  return (
    <div>
      <h2>All MCQs</h2>

      {mcqs.map((mcq, index) => {
        // ✅ supports both `correct` and `correctIndex`
        const correctAnswerIndex = mcq.correct ?? mcq.correctIndex;

        return (
          <div key={mcq._id} className="mcq-card">

            <h3>{index + 1}. {mcq.question}</h3>

            {mcq.options.map((opt, i) => (
              <div
                key={i}
                className={
                  showAnswer === mcq._id
                    ? i === correctAnswerIndex
                      ? "mcq-option correct"
                      : "mcq-option"
                    : "mcq-option"
                }
              >
                {String.fromCharCode(65 + i)}. {opt}
              </div>
            ))}

            <button
              className="show-answer-btn"
              onClick={() =>
                setShowAnswer(showAnswer === mcq._id ? null : mcq._id)
              }
            >
              {showAnswer === mcq._id ? "Hide Answer" : "Show Answer"}
            </button>

            {showAnswer === mcq._id && (
              <div className="mcq-explanation">
                <strong>Explanation:</strong> {mcq.explanation}
              </div>
            )}

            <p className="mcq-subject">Subject: {mcq.subject}</p>

          </div>
        );
      })}
    </div>
  );
}
